import * as React from "react";
import type { HeadFC, PageProps } from "gatsby";
import { Header } from "src/components/global/Header";
import { Footer } from "src/components/global/Footer";
import { PageHeader } from "src/components/global/PageHeader";
import { Contact } from "src/components/contact/Contact";

const ContactUsPage: React.FC<PageProps> = () => {
  return (
    <>
      <div className="relative">
        <Header />
        <PageHeader pageTitle={"Contact Us"} />
        <div id="contact-us-page" className="">
          <Contact />
        </div>
        <Footer />
      </div>
    </>
  );
};

export default ContactUsPage;

export const Head: HeadFC = () => (
  <title>Contact us today | Empire Welding</title>
);
